/**
 * Hängt den Gebäudenamen an den Raumnamen an: `R101 (Hauptgebäude)`.
 * Ist kein Gebäude gepflegt, bleibt der Raumname unverändert.
 */
export const getRoomLabelWithBuilding = (roomName: string, buildingName?: string | null): string => {
  const building = buildingName?.trim();
  return building ? `${roomName} (${building})` : roomName;
};

/**
 * Sortiert Raum-Zeilen nach Gebäude (alphabetisch), innerhalb eines Gebäudes nach Raumname.
 * Räume ohne gepflegtes Gebäude landen am Ende.
 */
export const sortRowsByBuilding = <T extends { label: string; subLabel?: string | null }>(rows: T[]): T[] => {
  return [...rows].sort((a, b) => {
    const buildingA = a.subLabel?.trim() ?? '';
    const buildingB = b.subLabel?.trim() ?? '';
    if (buildingA !== buildingB) {
      if (!buildingA) return 1;
      if (!buildingB) return -1;
      return buildingA.localeCompare(buildingB);
    }
    return a.label.localeCompare(b.label);
  });
};
